<template>
  <div class="container">
    <section class="row">
      <div class="col-12">
        <div class="h1 text-blue-700 m-0">
          Bonjour
          <v-highlight color="pink-300">
            {{ client.firstName }}
          </v-highlight>
        </div>
        <p class="mb-3">
          Bon retour parmi nous !
        </p>
      </div>
    </section>
    <v-documents class="mb-5" />
    <v-cross-selling class="my-5" />
    <v-news class="my-5" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui, routing } from '@/mixins';

import HomeDocuments from '@/components/homepage/HomeDocuments.vue';
import HomeCrossSelling from '@/components/homepage/HomeCrossSelling.vue';
import HomeNews from '@/components/homepage/HomeNews.vue';

export default {
  name: 'HomePage',
  components: {
    'v-news': HomeNews,
    'v-documents': HomeDocuments,
    'v-cross-selling': HomeCrossSelling,
  },
  mixins: [ui, routing],
  data() {
    return {
      shouldShowBankAccountModal: false,
    };
  },
  computed: {
    ...mapGetters({
      client: 'client/get',
      hasSetPassword: 'client/hasSetPassword',
      showModalState: 'ui/showModal',
      paymentMethods: 'payments/paymentMethods',
      goCardlessBankAccounts: 'payments/goCardlessBankAccounts',
      contracts: 'contracts/get',
      bankAccountModalShown: 'ui/bankAccountModalShown',
      dynamicComponentType: 'ui/dynamicComponentType',
    }),
    hasBankAccounts() {
      const paymentMethodsArray = Array.isArray(this.paymentMethods) ? this.paymentMethods : [];
      const stripeBankAccounts = paymentMethodsArray.filter(({ type }) => type !== 'CARD') || [];
      const goCardlessAccounts = this.goCardlessBankAccounts || [];
      const totalBankAccounts = stripeBankAccounts.length + goCardlessAccounts.length;
      return totalBankAccounts > 0;
    },
    hasActiveContracts() {
      const contracts = Array.isArray(this.contracts) ? this.contracts : [];
      return contracts.filter(({ status, parentId }) => status === 'ACTIVE' && !parentId).length > 0;
    },
  },
  beforeMount() {
    this.ui_showFooter(true);
    this.loadPaymentMethodsAndTriggerModal()
      .then((shouldShowBankAccountModal) => {
        if (shouldShowBankAccountModal) {
          if (!this.bankAccountModalShown && this.$route.name === 'homepage') {
            this.$store.dispatch('ui/setValue', { bankAccountModalShown: true });
            this.ui_showModalBankAccount();
          }
          return;
        }

        if (!this.hasSetPassword) {
          this.ui_showModalPassword();
        }
      });
  },
  beforeRouteLeave(to, from, next) {
    if (this.dynamicComponentType === 'bank-account') {
      this.ui_showModal(false);
    }
    next();
  },
  methods: {
    async loadPaymentMethodsAndTriggerModal() {
      try {
        await Promise.allSettled([
          this.$store.dispatch('payments/getPaymentMethods'),
          this.$store.dispatch('payments/getGoCardlessBankAccounts')
        ]);
      } catch (error) {
        // Continue even if there's an error
      }

      if (this.hasBankAccounts) {
        return false;
      }

      return this.hasActiveContracts;
    },
  },
};
</script>
